import React from "react";
import Card from "@material-ui/core/Card";
import { withRouter } from "react-router-dom";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import calender from "Assets/newicons/user-interface/calendar/outline/calendar-outline-16px.svg";

class ChecklistCard extends React.Component {
  onChecklistClick = (checklist) => () => {
    this.props.onChecklistClick(checklist);
  };

  getPurpose = (checklist) => {
    switch (checklist.purpose) {
      case 1:
        return "Onboarding";
      case 2:
        return "Offboarding";
      case 3:
        return "Promotion";
      default:
        return "Others";
    }
  };

  render() {
    const { checklist, selected } = this.props;
    let date;
    if (checklist.effectivefrom) {
      date = moment(checklist.effectivefrom);
    }

    return (
      <Card
        className={`${selected ? "ChecklistCard Selected" : "ChecklistCard"}`}
      >
        <CardContent
          onClick={this.onChecklistClick(checklist)}
          className="content"
        >
          <p className="cardText titleText">{checklist.checklistname}</p>
          <div className="cardText pending">
            <p>{checklist.activitycount}</p>
          </div>
          <p className="cardText date">
            <img src={calender} />
            {checklist.effectivefrom ? date.format("DD-MMM-YYYY") : 'No Due date'}
          </p>
          <p className="cardText type">
            <span>{this.getPurpose(checklist)}</span>
          </p>
        </CardContent>
      </Card>
    );
  }
}
export default withRouter(ChecklistCard);
